<app-spinner></app-spinner>
<div class="d-flex flex-column widthComponent">
  <div class="d-flex flex-column align-items-stretch heightComponent">
    <router-outlet (activate)="outletActivate()"></router-outlet>
    @if (pageLoaded) {
      <footer class="d-none d-xl-inline d-lg-inline d-md-inline bg-light footerPosition">
        <app-footer></app-footer>
      </footer>
    }
  </div>
</div>
